
/**
 * Function for OC First login behaviour
 */
export const OCFirstLogin = () => {
    let btnTest = document.getElementById('btn-email-test');
    let emailInput = document.getElementById('oc-email-test');
    let emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    let error = document.getElementById('email-error');
    let $ocGravityForm = document.querySelector('.oc-custom-sign-up > .oc-gravity-form');
    let $ocSignInForm = document.querySelector('.oc-custom-sign-up > .oc-custom-form');
    // let loader = document.querySelector('.lds-ellipsis');
    let errorMsg = document.getElementById('oc-first-sign-in-error');

    let ajaxURL = oc_first_ajax;

    let params = new URL(document.location).searchParams;
    let login_error = params.get('error')
    let param_email = params.get('email');

    if (login_error && login_error == 'no-login') {
        errorMsg.innerText = "Oops! This email address isn’t registered for OC First yet, you can sign up here.";
        // Show Signup form in gravity forms
        $ocGravityForm.classList.remove('hide');
        // Hide login form
        $ocSignInForm.classList.add('hide');

        //pass param email to the form
        if (param_email) {
            let txtEmail = $ocGravityForm.querySelector('[type="email"]');
            txtEmail.value = param_email;
        }
    }


    // Button test on click function
    if (btnTest) {

        $('#oc-first-form-tester').bind("keypress", function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                btnTest.click();
                return false;
            }
        });
        btnTest.addEventListener('click', async () => {

            //Validations
            if (emailInput.length == 0) {

            }

            //Test if email if accepted
            if (!emailInput.value.match(emailFormat)) {

                error.innerText = "Invalid email format";

                return;
            }

            // Button Style
            // show the button
            // loader.classList.remove('d-none');
            btnTest.innerHTML = "Checking your email...";

            let data = {
                action: "test_oc_email",
                email: emailInput.value
            };

            // send js to server and check if email is registered.s
            let uri = ajaxURL;
            let ajaxResult = await $.post(uri, data, (res) => {
                btnTest.innerHTML = "Next";
            }).done(res => {
                // loader.classList.add('d-none');
                return res;
            });

            // If Ajax is success, the cookie will be set on the backend and will redirect to sales page
            // or the previous property page
            if (ajaxResult.success) {
                // check if redirect is available on the payload. if it is, log-in user via ajax
                if (ajaxResult.data.session.redirect) {
                    let signInAjax = await ajaxSignIn(emailInput.value, ajaxResult.data);

                    // // if they are the same, just try to reload the page.
                    if (ajaxResult.data.session.redirection_url == window.location.href) {
                        btnTest.innerHTML = "Reloading, please wait....";
                        setTimeout(() => {
                            location.reload(true)
                        }, 1000);
                    } else {
                        btnTest.innerHTML = "Redirecting....";
                        setTimeout(() => {
                            window.location.replace(ajaxResult.data.session.redirection_url);
                        }, 1000);

                    }

                    //create a form that will send the email address to the oc sales site
                } else {
                    const url = ajaxResult.data.session.redirection_url;
                    const _form = document.createElement('form');
                    const _input = document.createElement('input');
                    const _btnSubmit = document.createElement('button');

                    // Create form
                    _form.method = "POST";
                    _form.action = url;

                    // Create input
                    _input.type = "text";
                    _input.name = "email_address";
                    _input.value = emailInput.value;
                    _btnSubmit.type = "submit";
                    _btnSubmit.textContent = "submit";

                    // Build Form
                    _form.appendChild(_input);
                    _form.appendChild(_btnSubmit);
                    document.body.appendChild(_form);

                    // Create dispatch event
                    const evt = new SubmitEvent('submit', { submitter: _btnSubmit });

                    // _form.dispatchEvent( evt );
                    _form.submit()
                }
            } else {
                // if failed, sign in form will be shown instead.
                //show the sign in form;
                if (!$ocSignInForm.classList.contains('hide')) {
                    $ocSignInForm.classList.add('hide');
                    $ocGravityForm.classList.remove('hide');
                } else {
                    $ocSignInForm.classList.remove('hide');
                    $ocGravityForm.classList.add('hide');
                }

                let gravEmail = $ocGravityForm.querySelector('[type="email"]');
                let buyerAlerts = (document.getElementById('label_15_7_1')) ? document.getElementById('label_15_7_1') : document.getElementById('label_24_7_1');
                let choiceBuyerAlerts = buyerAlerts.previousElementSibling;
                gravEmail.value = emailInput.value;

                errorMsg.innerText = "Oops! This email address isn’t registered for OC First yet, you can sign up here.";

                if (window.location.pathname == "/oc-first/") {

                    if (!choiceBuyerAlerts.checked) {
                        buyerAlerts.click();
                    }
                } else {
                    if (choiceBuyerAlerts.checked) {
                        buyerAlerts.click();
                    }
                }
            }



        });
    }


    //Email text field event listener
    if (emailInput) {
        emailInput.addEventListener('input', () => {

            // clear error if there are shown
            if (error.innerText !== "") {
                error.innerText = "";
            }
        })
    }
}


/**
 * Sends POST request to the oc first login then create
 * cookies to save the login.
 * 
 * @param {*} _email 
 * @param {*} _data 
 * @param {*} _anonymous 
 */
const ajaxSignIn = (_email, _data, _anonymous = false) => {
    let ajaxURL = oc_first_ajax;
    let uri = ajaxURL;
    let data = {
        action: "ajax_oc_login",
        sign_in_email: _email,
        anonymous: _anonymous,
        additional_data: _data
    };

    let ajaxResult = $.post(uri, data, (res) => {

    }).done(res => {
        return res;
    });
}